import SparkMD5 from 'spark-md5';
import CONSTANTS from '@/shared/constants/constants';
import { showDialog } from '@/shared/sweetAlerts/showDialog';
import QrCodeModal  from '../../../../qrcode/modal/index.vue';
import DicomPlusMixin from '@/shared/mixins/dicom-plus.mixin';

export default {
  name: 'AnexarArquivosModal',
  mixins: [DicomPlusMixin],
  components: {
    QrCodeModal
  },
  props: {
    visible: { type: Boolean, required: true },
    anexoTipoOptions: { type: Array, required: true },
    accept: { type: String, default: '.pdf,.jpg,.jpeg' },
    savedFiles: { type: Array, default: () => [] },
    status: { type: Number, default: 0 },
    exam: { type: Object, default: null },
  },
  data() {
    return {
      showQrCode: false,
      files: [],
      endpoint: `${import.meta.env.VITE_URL_API}/core/DicomPlus/CreateQrCodeSendFileByMobile`
    }
  },
  computed: {
    isSaveDisabled() {
      if (!this.files || !this.files.length) return true
      return this.files.some(file => !file.tipoAnexo)
    },
    separadorIndex() {
      const indicePedidoMedico = this.anexoTipoOptions
        .findIndex(tipo => tipo.value === CONSTANTS.DICOM_PLUS_TIPO_ANEXO.PEDIDO_MEDICO)
      return indicePedidoMedico === 0 && this.anexoTipoOptions.length > 1 ? 1 : -1
    }
  },
  methods: {
    getTipoAnexoLabel(tipoAnexo) {
      const found = this.anexoTipoOptions.find((opt) => opt.value === tipoAnexo)
      return found ? found.label : tipoAnexo
    },
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    async onFileChange(e) {
      const arquivos = Array.from(e.target.files || e)
      for (const arq of arquivos) {
        const isPDF = arq.type === 'application/pdf' && arq.name.toLowerCase().endsWith('.pdf');
        const isJPG = arq.type === 'image/jpeg' && (arq.name.toLowerCase().endsWith('.jpg') || arq.name.toLowerCase().endsWith('.jpeg'));
        if (!isPDF && !isJPG) {
          showDialog({
            icon: 'warning',
            title: 'Extensão inválida',
            text: `Somente arquivos PDF ou JPG são permitidos.`,
            confirmButtonText: 'OK'
          })
          continue;
        }

        const md5 = await this.getFileMD5(arq);
        const duplicado = this.files.some(a => a.md5 === md5);
        if (duplicado) {
          showDialog({
            icon: 'warning',
            title: 'Arquivo repetido',
            text: `Não é permitido selecionar arquivos repetidos`,
            confirmButtonText: 'OK'
          })
          continue
        }
        const fileData = {
          name: arq.name,
          size: arq.size,
          type: arq.type,
          lastModified: arq.lastModified,
          tipoAnexo: '',
          md5
        }
        if (isJPG) {
          const reader = new FileReader()
          reader.onload = (evt) => {
            this.files.push({
              ...fileData,
              preview: evt.target.result,
              file: arq
            })
          }
          reader.readAsDataURL(arq)
        } else if (isPDF) {
          // PDF não tem preview de imagem
          this.files.push({
            ...fileData,
            file: arq
          })
        }
      }
      e.target.value = ''
    },
    getFileMD5(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const md5 = SparkMD5.ArrayBuffer.hash(e.target.result);
          resolve(md5);
        }
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });
    },
    removeFile(idx) {
      this.files.splice(idx, 1)
    },
    emitSave() {
      this.$emit('save', { files: this.files })
    },
    emitClose() {
      this.$emit('close')
      this.files = []
    },
    clearImportedFiles() {
      this.files = []
    },
    abrirModalQrCode() {
      this.showQrCode = true
    },
    fecharModalQrCode() {
      this.showQrCode = false
    },
    async carregarListaArquivos(e){
      const listFile = e.photos.map(photo => {
        return {
          linkStorage: photo.id,
          tipoAnexo: photo.attachType,
        }
      })

      const payload = {
        dicomPlusID: this.exam.dicomPlusID,
        files: listFile,
      }

      this.$root.$emit('showLoading')

      try {
        await this.salvarAnexoLocal(payload)
        this.savedFiles = await this.getFileList(this.exam.dicomPlusID) || []
      } catch (error) {
        console.error('Error saving files:', error);
        showDialog({
          icon: 'error',
          title: 'Erro ao salvar arquivos',
          text: 'Por favor, tente novamente mais tarde.',
          confirmButtonText: 'OK'
        })
      } finally {
        this.$root.$emit('hideLoading')
      }

      await this.salvarAnexoLocal(payload)
      this.savedFiles = await this.getFileList(this.exam.dicomPlusID) || []
    }
  },

}
